module.exports = __webpack_public_path__ + "static/media/HomePageDivide_72dpi.d0aff56b.png";